/* eslint-disable no-useless-escape */
export const REGEXP_CONFIG = {
  ANY_CHARS: "^[\\s\\S]*$",
  SPECIAL_CHARS: '^[a-zA-Zа-яА-Я0-9!@#$%^&*,.?":{}|<>]+$',
  ALPHANUMERIC: "^[a-zA-Zа-яА-Я0-9]+$",
  ALPHANUMERIC_UNDERSCORE: "^[a-zA-Zа-яА-Я0-9_]+$",
  ALPHANUMERIC_UNDERSCORE_HYPHEN: "^[a-zA-Zа-яА-Я0-9_-]+$",
  ALPHANUMERIC_SPACE: "^[a-zA-Zа-яА-Я0-9 ]+$",
  ALPHA_UPPERCASE_NUMBERS: "^[A-ZА-Я0-9]+$",
  ALPHA_LOWERCASE_NUMBERS: "^[a-zа-я0-9]+$",
  NUMBERS_ONLY: "^[0-9]+$",
  NUMBERS_DOT: "^[0-9.]+$",
  LETTERS_ONLY: "^[a-zA-Zа-яА-Я]+$",
  LETTERS_SPACE: "^[a-zA-Zа-яА-Я ]+$",
  UPPERCASE_ONLY: "^[A-ZА-Я]+$",
  LOWERCASE_ONLY: "^[a-zа-я]+$",
  CYRILLIC_ONLY: "^[а-яА-Я]+$",
  LATIN_ONLY: "^[a-zA-Z]+$",
  CYRILLIC_UPPERCASE: "^[А-Я]+$",
  CYRILLIC_LOWERCASE: "^[а-я]+$",
  LATIN_UPPERCASE: "^[A-Z]+$",
  LATIN_LOWERCASE: "^[a-z]+$",
  LATIN_NUMBERS: "^[a-zA-Z0-9]+$",
  LATIN_UPPERCASE_NUMBERS: "^[A-Z0-9]+$",
  LATIN_LOWERCASE_NUMBERS: "^[a-z0-9]+$",
  CYRILLIC_NUMBERS: "^[а-яА-Я0-9]+$",
  CYRILLIC_UPPERCASE_NUMBERS: "^[А-Я0-9]+$",
  CYRILLIC_LOWERCASE_NUMBERS: "^[а-я0-9]+$",
  NON_LETTERS: "[^a-zA-Zа-яА-Я]+$",
};
